import { render, staticRenderFns } from "./TraxSettingTaskCrudSearch.vue?vue&type=template&id=304a903b"
import script from "./TraxSettingTaskCrudSearch.vue?vue&type=script&lang=js"
export * from "./TraxSettingTaskCrudSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports